import styled, { css } from 'styled-components';

const QRCodeStyled = styled.div`
  ${() => {
    return css`
      text-align: center;
      span {
        margin-top: 0.25em;
        display: block;
        font-weight: 700;
        font-size: 0.875em;
        line-height: 1.5em;
        color: var(--color-neutral-70);
      }
    `;
  }}
`;

export default QRCodeStyled;
